function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { isTabInvalid } from "../../../helpers/errorUtils";

class TmTabContentLabel extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: isTabInvalid(this.props.error, this.props.errorKeyPrefix) ? 'text-danger' : ''
      }, this.props.children));
    });
  }

}

export default TmTabContentLabel;